<app-configurar-agenda *ngIf="doctor.doc_id"
    [doctor]='doctor' >
</app-configurar-agenda>